import React, { useContext } from "react";
import { IonCol, IonRow } from '@ionic/react';
import { Button, Subtitulo } from 'app-principal-componentes-visuales';
import { LABEL_RIESGO, TELEFONO_WHATSAPP } from "../../../utils/constants";
import { ModulosDeshabilitados } from "../../../interfaces/modulosDeshabilitados.interface";
import { AsistenciaMedicaContext } from "../../../contexts/AsistenciaMedicaContext";

interface IContactanosProps {
    nombre?: string,
    texto?: string,
    textoWsp?: string,
    phone?: boolean,
    whatsapp?: boolean,
    riesgo?: boolean,
    isWeb?: boolean,
    deshabilitarModulo?: string
}

const BotonContactanos = ({nombre, texto, textoWsp, phone, whatsapp, riesgo, isWeb, deshabilitarModulo} :IContactanosProps) => {

    const { asistenciaMedica } = useContext(AsistenciaMedicaContext);
    const { statusModulos }: { statusModulos: ModulosDeshabilitados } = asistenciaMedica;
    let deshabilitarWhatsapp = statusModulos[deshabilitarModulo];
    const encodedText = encodeURIComponent(textoWsp)

    return (
        <>
            {
                (whatsapp && !deshabilitarWhatsapp) &&
                <IonRow className="contactanos-row">
                    <IonCol size='12'>
                        <Button
                            id={nombre}
                            href={
                                !isWeb 
                                        ? textoWsp 
                                            ? `whatsapp://send?phone=+54${TELEFONO_WHATSAPP()}&text=${textoWsp}`
                                            : `whatsapp://send?phone=+54${TELEFONO_WHATSAPP()}` 
                                        : textoWsp 
                                        ? `https://wa.me/549${TELEFONO_WHATSAPP()}?text=${encodedText}`
                                        : `https://wa.me/549${TELEFONO_WHATSAPP()}`
                            }
                            label={texto}
                            whatsapp={whatsapp}
                        />
                    </IonCol>
                </IonRow>
            }
            
            {
                phone &&
                <IonRow className="contactanos-row">
                    <IonCol size='12'>
                        <Button
                            id={nombre}
                            href={`tel:${texto}`}
                            label={texto}
                            phone={phone}
                        />
                    </IonCol>
                </IonRow>
            }

            {
                riesgo &&
                // Se comenta momentaneamente, ya que aun no hay definicion por parte de urgencias
                // (riesgo && !statusModulos?.deshabilitarWhatsappEmergencia) &&
                <IonRow className="contactanos-row">
                    <IonCol size='12'>
                        <Subtitulo
                            titulo={LABEL_RIESGO}
                            txtRed
                            id="subtitulo-riesgo"
                        />
                        <Button
                            id={nombre}
                            href={`tel:${texto}`}
                            label={texto}
                            primary
                            colorRed
                        />
                    </IonCol>
                </IonRow>
            }
        </>
    )
}

export default BotonContactanos